import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

export const reactPlugin = new ReactPlugin();

export const appInsights = new ApplicationInsights({
    config: {
        connectionString: `InstrumentationKey=${process.env.REACT_APP_ApplicationInsights ?? "00000000-0000-0000-0000-000000000000"}`,
        enableAutoRouteTracking: true,
        extensions: [reactPlugin]
    }
});

appInsights.loadAppInsights();